document.querySelectorAll('header a[href="#"]').forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault(); // Prevents the page jump to top
  });
});

$(document).ready(function () {



$(function () {
  var $header = $(".custom-header");
  var $announcement = $(".announcement-bar");

  // 1. Add/remove 'not-home' class
  function updateHeaderClass() {
    const isHome = $('.content-for-layout[data-template="index"]').length > 0;
    $header.toggleClass('not-home', !isHome);
  }

  // 2. Update announcement bar height as CSS variable
  function updateHeaderOffset() {
    const barHeight = $announcement.outerHeight() || 0;
    document.documentElement.style.setProperty("--announcement-height", barHeight + "px");
  }

  // 3. Toggle 'active-header' on scroll
  function updateHeaderState() {
    const scrolled = $(window).scrollTop() > 0;
    $header.toggleClass("active-header", scrolled);
  }

  // Initial calls
  updateHeaderClass();
  updateHeaderOffset();
  updateHeaderState();

  // Event listeners
  $(window).on("scroll", function () {
    updateHeaderClass();
    updateHeaderState();
  });
  $(window).on("resize", updateHeaderOffset);
});

  // ------------------------
  // Number Counter
  // ------------------------
  if ($('.counter-block').length) {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        $(entry.target).find('span.integer__').each(function () {
          const $this = $(this);

          // Remove commas so values such as 50,000 can be parsed.
          const rawValue = $this.text().trim().replace(/,/g, '');
          const targetValue = parseFloat(rawValue);

          if (Number.isNaN(targetValue)) return;

          // Detect decimal precision from the original value.
          // Examples:
          // 5     = 0 decimal places
          // 4.8   = 1 decimal place
          // 4.85  = 2 decimal places
          const decimalPlaces = rawValue.includes('.')
            ? rawValue.split('.')[1].length
            : 0;

          $this.prop('Counter', 0).animate(
            {
              Counter: targetValue
            },
            {
              duration: 1000,
              easing: 'swing',

              step: function (now) {
                const displayedValue = decimalPlaces > 0
                  ? Number(now.toFixed(decimalPlaces))
                  : Math.ceil(now);

                $this.text(
                  displayedValue.toLocaleString('en-US', {
                    minimumFractionDigits: decimalPlaces,
                    maximumFractionDigits: decimalPlaces
                  })
                );
              },

              complete: function () {
                // Ensure the exact target is displayed at the end.
                $this.text(
                  targetValue.toLocaleString('en-US', {
                    minimumFractionDigits: decimalPlaces,
                    maximumFractionDigits: decimalPlaces
                  })
                );
              }
            }
          );
        });

        // Run each counter block only once.
        obs.unobserve(entry.target);
      });
    }, observerOptions);

    $('.counter-block').each(function () {
      observer.observe(this);
    });
  }

  // ------------------------
  // Video Popup
  // ------------------------
  var $popup = $("#video-popup");
  var $popupInner = $popup.find(".video-popup__inner");
  var $marqueeInner = $(".social-marquee__inner");

  $(document).on("click", ".video-play-btn", function() {
    var videoHtml = $(this).data("video-html");
    $popupInner.html(videoHtml);
    $popup.addClass("active");
    $marqueeInner.addClass("paused");
  });

  $(document).on("click", ".video-popup__close, .video-popup__overlay", function() {
    $popup.removeClass("active");
    $popupInner.html("");
    $marqueeInner.removeClass("paused");
  });

  // ------------------------
  // Accordion
  // ------------------------


  $('.accordion-block').each(function () {
    const $items = $(this).find('.accordion-each');
    if (!$items.length) return;

    $items.first().addClass('open').find('.accordion-text').show();

    $(this).on('click', '.accordion-title', function () {
      const $clicked = $(this).closest('.accordion-each');
      $clicked.toggleClass('open').find('.accordion-text').stop(true, true).slideToggle(300);
      $items.not($clicked).removeClass('open').find('.accordion-text').slideUp(300);
    });
  });



(function($){

  $('.tab-accordion--block').each(function(){

    const $wrap = $(this);
    const $items = $wrap.find('.accordion-each');
    if (!$items.length) return;

    // Open first item by default
    $items.first().addClass('open')
      .find('.accordion-text')
      .show();

    // Click handler
    $wrap.on('click', '.accordion-title', function(){

      const $clicked = $(this).closest('.accordion-each');

      // Close all others
      $items.not($clicked)
        .removeClass('open')
        .find('.accordion-text')
        .stop(true,true)
        .slideUp(220);

      // Toggle clicked
      $clicked.toggleClass('open')
        .find('.accordion-text')
        .stop(true,true)
        .slideToggle(220);

      // Rotate icon (optional)
      $clicked.find('.accordion-icon svg').toggleClass('rotated');
      $items.not($clicked).find('.accordion-icon svg').removeClass('rotated');

    });

  });

})(jQuery);


  // ------------------------
  // Product Slider (Generic)
  // ------------------------
  var $sliders = $('.section-bottom--content__inner.product-slider.slider-stuff');
  if ($sliders.length) {
    $sliders.each(function () {
      var $this = $(this);
      var $products = $this.find('.product-grid-item');

      if ($products.length > 1 && !$this.hasClass('slick-initialized')) {
        $this.slick({
          dots: false,
          arrows: false,
          speed: 500,
          autoplay: false,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } }
          ]
        });
      }
    });

    $('.custom-product--prev').on('click', function () {
      $sliders.slick('slickPrev');
    });

    $('.custom-product--next').on('click', function () {
      $sliders.slick('slickNext');
    });
  }

  // ------------------------
  // Tabs
  // ------------------------
  $('.custom-tab').each(function() {
    var $section = $(this);
    var $buttons = $section.find('.tab-buttons');
    var $contents = $section.find('.accordion--each');

    if ($buttons.length && $contents.length) {
      $buttons.first().addClass('active');
      $contents.first().addClass('active');

      $buttons.on('click', function() {
        var index = $(this).index();
        $buttons.removeClass('active');
        $contents.removeClass('active');
        $(this).addClass('active');
        $contents.eq(index).addClass('active');
      });
    }
  });

  $('.custom-tab--location').each(function() {
    var $section = $(this);
    var $buttons = $section.find('.tab-buttons');
    var $contents = $section.find('.tab--each');

    if ($buttons.length && $contents.length) {
      $buttons.first().addClass('active');
      $contents.first().addClass('active');

      $buttons.on('click', function() {
        var index = $(this).index();
        $buttons.removeClass('active');
        $contents.removeClass('active');
        $(this).addClass('active');
        $contents.eq(index).addClass('active');
      });
    }
  });

  // ------------------------
  // Popular Product Slider
  // ------------------------
if ($('.custom-popular--product .single-slider').length) {
  const $slider = $('.custom-popular--product .single-slider');

  function updatePrevClass() {
    $slider.find('.slick-slide').removeClass('is-prev');

    let $prev = $slider.find('.slick-active').first().prev('.slick-slide');

    // Handle infinite loop
    if (!$prev.length) {
      $prev = $slider.find('.slick-slide').last();
    }

    $prev.addClass('is-prev');
  }

  $slider.on('init afterChange', function () {
    updatePrevClass();
  });

  $slider.slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.popular-prduct--prev').on('click', function () {
    $slider.slick('slickPrev');
  });

  $('.popular-prduct--next').on('click', function () {
    $slider.slick('slickNext');
  });
}






 

  const $collectionSliders = $('.product-slider .collection-products');

  if ($collectionSliders.length) {

    $collectionSliders.each(function () {
      const $slider = $(this);

      // Initialize Slick
      $slider.slick({
        dots: false,
        arrows: false,
        speed: 500,
        autoplay: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          { breakpoint: 1280, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 900, settings: { slidesToShow: 1, slidesToScroll: 1 } }
        ]
      });

      // Handle Prev/Next button disabling
      $slider.on('init reInit afterChange', function (event, slick) {
        updateButtons($slider, slick);
      });

    });
  }

  // Function to update Prev/Next buttons for a specific slider
  function updateButtons($slider, slick) {
    const $prev = $('.custom-slick--prev');
    const $next = $('.custom-slick--next');

    const slidesToShow = slick.options.slidesToShow;
    const totalSlides = slick.slideCount;
    const current = slick.currentSlide;

    if (totalSlides <= slidesToShow) {
      $prev.addClass('disabled');
      $next.addClass('disabled');
      return;
    }

    $prev.toggleClass('disabled', current === 0);
    $next.toggleClass('disabled', current >= totalSlides - slidesToShow);
  }

  // Prev / Next button clicks
  $('.custom-slick--prev').on('click', function () {
    const $visible = $('.collection-products:visible');
    if (!$visible.length || $(this).hasClass('disabled')) return;

    $visible.slick('slickPrev');
  });

  $('.custom-slick--next').on('click', function () {
    const $visible = $('.collection-products:visible');
    if (!$visible.length || $(this).hasClass('disabled')) return;

    $visible.slick('slickNext');
  });

  // ===============================
  // Collection filter buttons logic
  // ===============================
  const $buttons = $('.filter-btn');
  const $collections = $('.collection-products');
  $collections.hide();

  let $activeBtn = $buttons.filter('.active');
  if (!$activeBtn.length) $activeBtn = $buttons.first().addClass('active');

  // Show first active collection
  const firstHandle = $activeBtn.data('collection-handle');
  const $firstCollection = $collections.filter('[data-collection-handle="' + firstHandle + '"]');
  $firstCollection.show();
  if ($firstCollection.hasClass('slick-initialized')) {
    $firstCollection.slick('setPosition');
    updateButtons($firstCollection, $firstCollection.slick('getSlick'));
  }

  // Click event for filters
  $buttons.on('click', function () {
    const handle = $(this).data('collection-handle');

    $buttons.removeClass('active');
    $(this).addClass('active');

    $collections.each(function () {
      const $collection = $(this);
      if ($collection.data('collection-handle') === handle) {
        $collection.fadeIn(200, function () {
          if ($collection.hasClass('slick-initialized')) {
            $collection.slick('setPosition');
            updateButtons($collection, $collection.slick('getSlick'));
          }
        });
      } else {
        $collection.hide();
      }
    });
  });







  const $container = $('.custom-product--block .filter-buttons');
  function updateDividers() {
    $container.find('.filter-divider').css('opacity', '1');

    const $active = $container.find('.filter-btn.active');

    if ($active.length) {
      $active.next('.filter-divider').css('opacity', '0');
      $active.prev('.filter-divider').css('opacity', '0');
    }
  }

  updateDividers();

  $container.on('click', '.filter-btn', function () {
    $container.find('.filter-btn').removeClass('active');
    $(this).addClass('active');
    updateDividers();
  });





// Custom Block Slider

  if ($('.custom-block--slider .slider--content--inner').length) {
    const $slider = $('.custom-block--slider .slider--content--inner');

    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    $('.custom-block--slider .block-prev').on('click', function () {
      $slider.slick('slickPrev');
    });

    $('.custom-block--slider .block-next').on('click', function () {
      $slider.slick('slickNext');
    });
  }


// Custom Block Slider Hover Effect

  if ($('.custom-block--slider .block-each').length) {
    $('.custom-block--slider .block-each').hover(
      function () {
        $(this).find('.block-content__hidden').stop(true, true).slideDown(250);
      },
      function () {
        $(this).find('.block-content__hidden').stop(true, true).slideUp(250);
      }
    );
  }





// Changing the text in buy button

  function updateBuyNowText() {
    var $buyNowBtn = $('.shopify-payment-button__button');
    if ($buyNowBtn.length && $buyNowBtn.text() !== 'Buy in one click') {
      $buyNowBtn.text('Buy in one click');
    }
  }

  updateBuyNowText();

  setTimeout(updateBuyNowText, 1000);

  const observer = new MutationObserver(updateBuyNowText);
  observer.observe(document.body, { childList: true, subtree: true });




// Variant Option For Boots


function initHorizonProductTotal() {
  const $form = $('.shopify-product-form');
  const $quantityInput = $form.find('input[name="quantity"]');
  const $priceEl = $form.find('.price-item--regular, [data-product-price]');
  const $totalEl = $form.find('#total-price');

  if (!$form.length || !$quantityInput.length || !$priceEl.length || !$totalEl.length) return;

  function getPrice() {
    let priceCents = 0;
    if ($priceEl.attr('data-price')) {
      priceCents = parseFloat($priceEl.attr('data-price'));
    } else {
      const text = $priceEl.text().replace(/[^0-9.]/g, '');
      priceCents = parseFloat(text) * 100;
    }
    return priceCents;
  }

  function updateTotal() {
    const price = getPrice();
    const qty = parseInt($quantityInput.val()) || 1;
    const total = (price * qty / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    $totalEl.text(total);
  }

  // Initialize
  updateTotal();

  // Listen to quantity changes (typing, plus/minus buttons)
  $quantityInput.on('input change', updateTotal);
  $form.find('.quantity-plus, .quantity-minus').on('click', function() {
    setTimeout(updateTotal, 50); // small delay to allow input value to update
  });

  // Listen for Shopify variant changes
  $(document).on('variant:change', function(event) {
    const variant = event.originalEvent.detail.variant;
    if (variant) {
      // Update price element
      if ($priceEl.attr('data-price')) {
        $priceEl.attr('data-price', variant.price);
      } else {
        $priceEl.text((variant.price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        }));
      }
      updateTotal();
    }
  });
}

// Call on page load
$(document).ready(function() {
  initHorizonProductTotal();
});



	if ($('.customized--post-content').length) {
	  const usedIds = new Set();
	  $('.customized--post-content h2.wp-block-heading').each(function () {
	    let id = $(this).text().toLowerCase().trim()
	      .replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
	    let base = id || 'section', i = 1;
	    while (!id || usedIds.has(id)) id = `${base}-${i++}`;
	    usedIds.add(id);
	    this.id = id;
	  });

	  const $toc = $('.pcs--list ul').empty();
	  $('.customized--post-content h2.wp-block-heading').each(function () {
	    $toc.append(`<li><a href="#${this.id}" data-target="${this.id}">${$(this).text().trim()}</a></li>`);
	  });

	  const HEADER_OFFSET = 150;
	  let isAutoScrolling = false;
	  let lockActiveTo = null; 
	  const root = document.documentElement;
	  const hadSmooth = getComputedStyle(root).scrollBehavior === 'smooth';

	  function setActiveById(id) {
	    if (!id) return;
	    $('.post-contents--sidebar ul li').removeClass('active');
	    $(`.post-contents--sidebar ul li a[href="#${id}"]`).parent().addClass('active');
	  }

	  $('.pcs--list a').on('click', function (e) {
	    e.preventDefault();
	    const targetId = $(this).data('target');
	    const $target = $('#' + targetId);
	    if (!$target.length) return;

	    lockActiveTo = targetId;
	    isAutoScrolling = true;
	    setActiveById(targetId);

	    if (hadSmooth) root.style.scrollBehavior = 'auto';

	    $('html, body').stop(true, false).animate(
	      { scrollTop: $target.offset().top - HEADER_OFFSET },
	      500,
	      () => {
	        setTimeout(() => {
	          isAutoScrolling = false;
	          lockActiveTo = null;
	          if (hadSmooth) root.style.scrollBehavior = '';
	          updateActiveNavItem();
	        }, 60);
	      }
	    );
	  });

	  function updateActiveNavItem() {
	    if (isAutoScrolling || lockActiveTo) return;

	    const scrollY = $(window).scrollTop();
	    let currentId = null;

	    $('.customized--post-content h2.wp-block-heading').each(function () {
	      const top = $(this).offset().top - (HEADER_OFFSET + 8);
	      if (scrollY >= top) currentId = this.id;
	      else return false; 
	    });

	    if (currentId) setActiveById(currentId);
	  }

	  let ticking = false;
	  $(window).on('scroll', () => {
	    if (!ticking) {
	      ticking = true;
	      requestAnimationFrame(() => { updateActiveNavItem(); ticking = false; });
	    }
	  });

	  updateActiveNavItem();
	}

  



(function($) {
  $('.custom-tabs-accordion').each(function() {

    const $section = $(this);
    const $tabs = $section.find('.tab-link');
    const $panels = $section.find('.tab-content');

    // Initial state
    $panels.hide().first().show();
    $tabs.first().addClass('active');

    // Tab click
    $tabs.on('click', function() {

      const tabId = $(this).data('tab');
      const $targetPanel = $section.find('#' + tabId);

      // Switch active tab
      $tabs.removeClass('active');
      $(this).addClass('active');

      // Show correct panel
      $panels.hide();
      $targetPanel.fadeIn(300);

    });

  });
})(jQuery);








// SHow and Hide Password
  function initShowHidePassword() {
    $('.toggle-password').each(function() {
      const $btn = $(this);
      const $input = $btn.siblings('input[type="password"], input[type="text"]');

      $btn.on('click', function() {
        const isPassword = $input.attr('type') === 'password';
        $input.attr('type', isPassword ? 'text' : 'password');

        // Toggle SVGs inside the button
        $btn.find('.show-icon').toggle(!isPassword);
        $btn.find('.hide-icon').toggle(isPassword);

        $btn.attr('aria-label', isPassword ? 'Hide password' : 'Show password');
      });
    });
  }

  $(document).ready(function() {
    initShowHidePassword();
  });




$(function () {
  // Run ONLY on customer pages
  if (!$('body').is('[class*="customers-"]')) return;

  const $form = $('form[action*="/account"]');
  if (!$form.length) return;

  const $password = $('#CreatePassword');
  const $confirm = $('#ConfirmPassword');
  const $consent = $('#ConsentCheckbox');
  const $passwordError = $('.error-message');
  const $consentError = $('.error-message-consent');

  $form.on('submit', function (e) {
    let valid = true;

    if ($password.length && $confirm.length) {
      if ($password.val() !== $confirm.val()) {
        $passwordError.show();
        valid = false;
      } else {
        $passwordError.hide();
      }
    }

    if ($consent.length) {
      if (!$consent.is(':checked')) {
        $consentError.show();
        valid = false;
      } else {
        $consentError.hide();
      }
    }

    if (!valid) e.preventDefault();
  });
});






function initRecoverToggle() {
  var $loginPage = $('.customer-login-page').not('#RecoverPage'); // login page
  var $recoverPage = $('#RecoverPage'); // recover form section
  var $recoverForm = $recoverPage.find('form');

  function toggleRecover() {
    if (window.location.hash === '#recover' || $recoverPage.find('.success-message').length) {
      $loginPage.hide();
      $recoverPage.show();
    } else {
      $loginPage.show();
      $recoverPage.hide();
    }
  }

  toggleRecover();

  // "Forgot your password?" link
  $('.customer-links a[href$="#recover"]').on('click', function(e) {
    e.preventDefault();
    window.location.hash = '#recover';
    toggleRecover(); // show recover page immediately
  });

  // "Back to Login" button
  $recoverPage.on('click', 'a.back-to-login', function(e) {
    e.preventDefault();
    window.location.hash = '';
    toggleRecover();
  });

  $(window).on('hashchange', toggleRecover);

  // --- AJAX Reset Password ---
  $recoverForm.on('submit', function(e) {
    e.preventDefault();

    var $form = $(this);
    var email = $form.find('input[name="email"]').val();

    // Clear previous messages
    $recoverPage.find('.section-text, .errors, .success-message').remove();

    $.ajax({
      type: 'POST',
      url: '/account/recover',
      data: { email: email },
      dataType: 'json',
      success: function(response) {
        // Hide form, show success message inside the same recover page
        $form.hide();
        $recoverPage.append(`
          <div class="section-text success-message">
            <p>We’ve sent you an email with instructions to reset your password. Please check your inbox.</p>
          </div>
          <a href="/account/login" class="button button--primary w-full back-to-login">Back to Login</a>
        `);

        // Make sure the recover page stays visible and login stays hidden
        $loginPage.hide();
        $recoverPage.show();
      },
      error: function(xhr) {
        var errors = xhr.responseJSON && xhr.responseJSON.errors ? xhr.responseJSON.errors.join('<br>') : 'Something went wrong. Please try again.';
        $recoverPage.prepend(`<div class="errors" style="color:red; margin-bottom:1rem;">${errors}</div>`);
      }
    });
  });
}

$(document).ready(function() {
  initRecoverToggle();
});









function autoAccordionWithProgressV1(containerSelector, stepDuration = 5000) {
  const $container = $(containerSelector);
  const $steps = $container.find(".accordion-each");
  const totalSteps = $steps.length;

  let timer = null;
  let autoPlay = true; 
  let currentIndex = 0;

  function resetAll(exceptIndex = -1) {
    $steps.each(function (i) {
      if (i === exceptIndex) return;
      const $step = $(this);
      $step.removeClass("open");
      $step.find(".accordion-text").slideUp(300);
      $step.find(".timeline-progress").css({
        width: "100%",
        transform: "scaleX(0)",
        transformOrigin: "left",
        transition: "none"
      });
      $step.find(".timeline-dot").css({
        left: "0%",
        transition: "none"
      });
    });
  }

  function startProgress(index) {
    const $step = $steps.eq(index);
    const $progress = $step.find(".timeline-progress");
    const $dot = $step.find(".timeline-dot");

    clearTimeout(timer);

    if (autoPlay && index === 0) {
      resetAll();
    }

    $steps.not($step).find(".accordion-text").stop(true, false).slideUp(300);

    $step.find(".accordion-text").stop(true, false).slideDown(300, function () {
      $step.addClass("open");
      $progress.css({
        width: "100%",
        transform: "scaleX(0)",
        transformOrigin: "left",
        transition: "none"
      });
      $dot.css({ left: "0%", transition: "none" });

      $progress[0].offsetHeight; 

      $progress.css({
        transition: `transform ${stepDuration}ms linear`,
        transform: "scaleX(1)"
      });
      $dot.css({
        transition: `left ${stepDuration}ms linear`,
        left: "100%"
      });

      if (autoPlay) {
        timer = setTimeout(() => {
          currentIndex = index + 1;
          if (currentIndex >= totalSteps) currentIndex = 0; // loop
          startProgress(currentIndex);
        }, stepDuration);
      }
    });
  }

  startProgress(currentIndex);

  $container.on("click", ".accordion-each", function () {
    const $clicked = $(this);
    const clickedIndex = $steps.index($clicked);

    autoPlay = false;
    clearTimeout(timer);

    resetAll(clickedIndex);

    startProgress(clickedIndex);
  });
}

$(document).ready(function () {
  const sections = document.querySelectorAll('.custom-accordion--v1');

  if (!sections.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const section = entry.target;

        if (section.dataset.accordionStarted === 'true') return;

        section.dataset.accordionStarted = 'true';

        autoAccordionWithProgressV1(section, 7000);

        obs.unobserve(section);
      });
    },
    {
      threshold: 0.25
    }
  );

  sections.forEach((section) => {
    observer.observe(section);
  });
});






function initMobileSlider() {
  var $slider = $('.testimonial-slider-mobile .testimonial-track');

  if ($(window).width() < 751) {

    if (!$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: false,
        arrows: false,
        speed: 500,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        swipe: true,
        touchMove: true
      });
    }

  } else {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }
}

/* Custom Prev / Next */
$(document).on('click', '.testimonial-slider-mobile .block-prev', function () {
  $('.testimonial-slider-mobile .testimonial-track').slick('slickPrev');
});

$(document).on('click', '.testimonial-slider-mobile .block-next', function () {
  $('.testimonial-slider-mobile .testimonial-track').slick('slickNext');
});


initMobileSlider();

$(window).on('resize', function () {
  initMobileSlider();
});



//GLossary

  var first_char = $('.glossary-item').first().data('letter') || '#';
  first_char = first_char.toString().toUpperCase();

  function showItems(letter) {
    letter = letter.toString().toUpperCase();
    var items = $('.glossary-item[data-letter="' + letter + '"]');
    $('.glossary-item').hide();

    $('.glossary-empty-message').remove();

    if (items.length > 0) {
      items.show();
    } else {
      $('.glossary-entries--content').append(
        '<div class="glossary-empty-message">We don’t have any glossary terms starting with the letter "' + letter + '" yet.</div>'
      );
    }

    $('.glossary-selected-letter').text('"' + letter + '"');
  }

  showItems(first_char);

  $('.letter-filter').on('click', function(e) {
    e.preventDefault();
    var letter = $(this).data('letter');

    $('.letter-filter').removeClass('active');
    $(this).addClass('active');

    showItems(letter);
  });

  $('.clear-all').on('click', function(e) {
    e.preventDefault();
    $('.letter-filter').removeClass('active');
    $('.letter-filter[data-letter="' + first_char + '"]').addClass('active');

    showItems(first_char);
  });



$('a[href^="#"]').on('click', function(e) {
  var target = $($(this).attr('href')); 
  if(target.length) {
    e.preventDefault(); 
    var headerHeight = $('.site-header').outerHeight() || 0; 
    var scrollTo = target.offset().top - headerHeight;

    $('html, body').animate({
      scrollTop: scrollTo
    }, 600); 
  }
});


var $accordions = $(".product-media-accordion .product-accordion--each");

if ($accordions.length) {

  $accordions.each(function() {
    $(this).find(".accordion-content").hide();
    $(this).removeClass("open");
  });

  var $first = $accordions.first();
  $first.addClass("open").find(".accordion-content").show();

  $accordions.find("summary").on("click", function(e) {
    e.preventDefault(); 
    var $current = $(this).closest(".product-accordion--each");
    var $content = $current.find(".accordion-content");

    if ($current.hasClass("open")) {
      $content.slideUp(300);
      $current.removeClass("open");
    } else {
      $accordions.removeClass("open").find(".accordion-content").slideUp(300);
      $content.slideDown(300);
      $current.addClass("open");
    }
  });
}






function custom_function() {
  $(function () {

    const $root = $('.custom-single--product');
    const $qtyInput = $root.find('input[name="quantity"]');
    const $totalPrice = $root.find('#total-price');

    if (!$qtyInput.length || !$totalPrice.length) return;

    let lastBasePrice = null;

    // ---------- Replace this with actual max quantity for variant ----------
    // For now, we assume you can get it from data attribute or backend
    const maxQty = parseInt($qtyInput.data('max-quantity'), 10) || 10;

    function getBasePrice() {
      const priceText = $root
        .find('product-price .custom-price--wrapper .price')
        .first()
        .text();

      if (!priceText) return 0;

      return parseFloat(priceText.replace(/[^0-9.-]+/g, '')) || 0;
    }

    function formatMoney(value) {
      return '$' + value.toFixed(2);
    }

    function updateTotal(force = false) {
      let qty = parseInt($qtyInput.val(), 10) || 1;

      // ---------- Check against max quantity ----------
      if (qty > maxQty) {
        alert(`Only ${maxQty} item(s) available for this variant.`);
        qty = maxQty;
        $qtyInput.val(qty);
      }

      const basePrice = getBasePrice();

      // Only react if price actually changed or force update
      if (!force && basePrice === lastBasePrice) return;

      lastBasePrice = basePrice;

      const total = basePrice * qty;
      $totalPrice.text(formatMoney(total));

      $totalPrice.css('opacity', '0.4');
      setTimeout(() => $totalPrice.css('opacity', '1'), 120);
    }

    /* Quantity changes */
    $qtyInput.on('input change blur', function () {
      updateTotal(true);
    });

    $(document).on(
      'click',
      '.custom-single--product .quantity-plus, .custom-single--product .quantity-minus',
      function () {
        updateTotal(true);
      }
    );

    /* Observe ANY price change (category / size / variant) */
    const priceWrapper = $root.find('product-price')[0];
    if (priceWrapper) {
      const observer = new MutationObserver(() => {
        updateTotal(true);
      });

      observer.observe(priceWrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    /* Init */
    updateTotal(true);
  });
}

custom_function();




  
});


